import { Chart } from 'chart.js';

export interface NoDataPlugin {
  id: string;
  afterDatasetsDraw: (chart: Chart) => void;
}

export const noDataPlugin: NoDataPlugin = {
  id: 'noData',
  afterDatasetsDraw: (chart: Chart) => {
    const {
      ctx,
      data,
      chartArea: { top, left, width, height },
    } = chart;

    // Function to check if there is any data available (Non-zero number in datasets)
    const hasData = data.datasets.some((dataset) => {
      if (dataset === null) return false;
      if (Array.isArray(dataset.data)) {
        return dataset.data.some((item) => {
          if (item == null) return false;
          if (typeof item === 'number') {
            return item !== 0;
          }
          if (typeof item === 'string') {
            return parseFloat(item) !== 0;
          }
          // Handle BubbleDataPoint and Point chart types
          if (typeof item === 'object') {
            if ('r' in item && 'x' in item && 'y' in item) {
              // BubbleDataPoint
              return item.x !== 0 || item.y !== 0 || item.r !== 0;
            }
            if ('x' in item && 'y' in item) {
              // Point
              return item.x !== 0 || item.y !== 0;
            }
          }
          return false;
        });
      }
      return false;
    });

    if (!hasData) {
      ctx.save();
      ctx.font = 'bold 16px sans-serif';
      ctx.fillStyle = 'black';
      ctx.textAlign = 'center';
      ctx.fillText('No data available', left + width / 2, top + height / 2);
      return;
    }
  },
};
